import { provideMockStore } from '@ngrx/store/testing';
import { ConfigState } from '@digitaix/types';

export function getStoreStateWithConfig(config: Partial<ConfigState>) {
  return {
    dx: {
      config
    }
  }
}

export function provideMockStoreWithConfig(config: Partial<ConfigState>) {
  return provideMockStore({
    initialState: getStoreStateWithConfig(config),
  })
}
